/**
 * @file 模态弹窗包装器
 * @author liudayu
 */

import React, { ComponentClass, FunctionComponent } from 'react';
import { createRoot, Root } from 'react-dom/client';
import ThemeConfigProvider from 'common/src/config/theme/themeConfig';
import { $document, appendChild } from '@umu/umu-dom';

export interface IWrapperConfig {
    appendTo?: string;
    contentComponent?: ComponentClass<any> | FunctionComponent<React.PropsWithChildren<any>>;
}

function modalServiceWrapper<T extends IWrapperConfig>(dialogComponent: ComponentClass<T>, hasChild = false) {
    const DialogComponent = dialogComponent;

    const func = (config: T) => {
        let root: Root | null;
        const hostEl = $document.createElement('div');
        hostEl.className = 'dialog-wrapper';
        appendChild(hostEl, config.appendTo || '');

        function close() {
            // const afterClose = destroy.bind(this, ...args);
            render({ ...(config as object), close, showDialog: false, afterClose: destroy });
        }

        function destroy(): any {
            if (root) {
                root.unmount();
                root = null;
            }
            if (hostEl.parentNode) {
                hostEl.parentNode.removeChild(hostEl);
            }
        }

        function render(props: any) {
            const ChildComponent = config.contentComponent;
            const childComponentProps = props.childProps;
            if (hasChild && ChildComponent) {
                const childProps = {
                    closeDialog: close,
                    ...childComponentProps,
                };
                if (!root) {
                    root = createRoot(hostEl!);
                }
                root.render(
                    <ThemeConfigProvider>
                        <DialogComponent {...props}>
                            <ChildComponent {...childProps}></ChildComponent>
                        </DialogComponent>
                    </ThemeConfigProvider>,
                );
            } else {
                if (!root) {
                    root = createRoot(hostEl!);
                }
                root.render(
                    <ThemeConfigProvider>
                        <DialogComponent {...props} />
                    </ThemeConfigProvider>,
                );
            }
        }

        render({ ...(config as object), showDialog: true, close });

        return {
            destroy: close,
        };
    };

    return func;
}

export default modalServiceWrapper;
